<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>

    <section class="section">
      LINE Name: <input type="text" class="input" name="lineUser" v-model="lineUser" style="width:150px;margin-right:5px;"><button  class="button is-danger" id="submit-button" name="submit-button" v-on:click="searchData" >Search</button>
      <br><br>
      <section class="hero is-dark" v-show="dataAlready && !startSearch">
        <div class="hero-body">
          <div class="container">
            <h2 class="title">
              Car List
            </h2>
          </div>
        </div>
      </section>

      <div class="container">
        <span v-show="!dataAlready && startSearch">Loading....</span>
        <div class="card" v-for="car in carList" v-bind:key="car.id" style="margin: 30px;">
          <div class="card-content">
            <p class="title">
              ทะเบียน: {{car.licenseNo}}
            </p>
            <p class="subtitle">
              {{car.frameNo}}
            </p>

              <div class="columns">
                <div class="column">ชื่อลูกค้า: {{car.customerName}}</div>
                <div class="column" v-if="car.Model">Model: {{car.Model}}</div>
                <div class="column" v-if="car.carColor">Color: {{car.carColor}}</div>
              </div>

          </div>
        </div>
      </div>

      <section class="hero is-info" v-if="dataAlreadyJob && !startSearch">
        <div class="hero-body">
          <div class="container">
            <h2 class="title">
              Job List
            </h2>
          </div>
        </div>
      </section>

      <div class="container">
        <span v-show="!dataAlreadyJob && startSearch">Loading....</span>
        <div class="card" v-for="job in jobList" v-bind:key="job.id" style="margin: 30px;">
          <div class="card-content">
            <p class="title">
              ทะเบียน: {{job.licenseNo}}
            </p>
            <p class="subtitle">
              {{job.frameNo}}<br>
              {{showBranch(job.branchId)}} - {{job.runNo}}
            </p>
              <div class="columns">
                <div class="column">สถานะ: {{job.status}}</div>
                <div class="column">วันเวลาเข้า: {{formatDate(job.createdAt)}}</div>
                <div class="column">คาดว่าน่าจะเสร็จ: {{job.expectedDate}} {{job.expectedTime}}</div>
                <div class="column">วันเวลาอัพเดท: {{formatDate(job.updatedAt)}}</div>
              </div>

          </div>
        </div>
      </div>
    </section>
  </div>

</template>
<style scoped>
.banner {
  text-align: center;
  background-color: #000;
}
.hero-body {
  padding: 1.5rem 1.5rem !important;
}
.section {
  padding: 1rem .2rem !important;
}
.txt_small {
  font-size: 10px;
}
.section_form {
  width: 400px;
  margin: 0 auto;
}
</style>
<script>
export default {
  name: 'Home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {},
  data: () => ({
    dataAlready: false,
    dataAlreadyJob: false,
    startSearch: false,
    saving: false,
    carId: '',
    carList: [],
    jobList: [],
    lineUser: ''
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  methods: {
    showBranch (id) {
      let result = ''
      this.$branchList.map((item) => {
        result = (item.id === id) ? item.name : result
        return true
      })
      return result
    },
    async searchData () {
      this.startSearch = true
      await this.searchCar()
      this.startSearch = false
    },
    async searchCar () {
      let _this = this
      this.carList = []
      this.jobList = []
      _this.dataAlready = false
      this.$axios
        .get(`${this.$apiUrl}getCarByLineUser?lineUser=${_this.lineUser}`)
        .then(response => {
          _this.dataAlready = true
          _this.carList = response.data
          this.searchJob()
        })
    },
    async searchJob () {
      if (this.carList.length > 0) {
        let _this = this
        _this.dataAlreadyJob = false
        this.$axios
          .get(`${this.$apiUrl}getJobUser?userId=${this.carList[0].userId}`)
          .then(response => {
            _this.dataAlreadyJob = true
            _this.jobList = response.data
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SearchByLine.vue